import { bindActionCreators } from 'redux';
import { Map } from 'immutable';
import { connect } from '../../../../react-redux';
import * as modificationActions from '../../../../actions/modifications';
import * as quizEntriesApiActions from '../../../../../building/api/quizEntries';
import * as stimuliApiActions from '../../../../../building/api/stimuli';
import * as uiActions from '../../../../actions/ui';
import * as alertActions from '../../../../actions/alerts';
import * as errorsShowingActions from '../../../../actions/errorsShowing';
import * as modalActions from '../../../../../common/actions/modal';
import { uploadStatus } from '../../../../actions/upload';
import { ADD_CONTENT_POPOVER_KEY } from '@instructure/quiz-common';
import WrappedStimulusEdit from './presenter';
function mapStateToProps(state, props) {
  var addContentPopoverOpen = state.get('editing', Map()).find(function (isEditing, key) {
    return isEditing && key.includes(ADD_CONTENT_POPOVER_KEY);
  });
  return {
    addContentPopoverOpen: Boolean(addContentPopoverOpen),
    nextQuizEntry: state.getIn(['modifications', 'nextQuizEntry'], null),
    appContainer: state.getIn(['ui', 'appContainer']),
    workingStimulus: props.stimulus.getWorkingInstance(),
    workingQuizEntry: props.quizEntry.getWorkingInstance()
  };
}
function mapDispatchToProps(dispatch) {
  var modActions = bindActionCreators(modificationActions, dispatch);
  var quizEntryApiActions = bindActionCreators(quizEntriesApiActions, dispatch);
  var stimulusApiActions = bindActionCreators(stimuliApiActions, dispatch);
  var boundErrorsShowingActions = bindActionCreators(errorsShowingActions, dispatch);
  var boundModalActions = bindActionCreators(modalActions, dispatch);
  return {
    clearTemporaryStimulus: modActions.clearTemporaryStimulus,
    clearModifications: modActions.clearModifications,
    clearNextQuizEntry: modActions.clearNextQuizEntry,
    createQuizEntry: quizEntryApiActions.createQuizEntry,
    createStimulus: stimulusApiActions.createStimulus,
    createStimulusAndQuizEntry: quizEntryApiActions.createStimulusAndQuizEntry,
    createTempItem: modActions.createItem,
    createTempStimulus: modActions.createStimulus,
    getQuizEntries: quizEntryApiActions.getQuizEntries,
    hideError: boundErrorsShowingActions.hideError,
    openModal: boundModalActions.openModal,
    screenreaderNotification: bindActionCreators(alertActions, dispatch).screenreaderNotification,
    setUi: bindActionCreators(uiActions, dispatch).set,
    setUploadStatus: bindActionCreators(uploadStatus, dispatch),
    showError: boundErrorsShowingActions.showError,
    updateQuizEntry: quizEntryApiActions.updateQuizEntry,
    updateStimulus: stimulusApiActions.updateStimulus,
    withConfirm: boundModalActions.withConfirm
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(WrappedStimulusEdit);